var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    viewBox: "0 0 27 27.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-pdf-solid",
    d: "M0,3.484A3.487,3.487,0,0,1,3.484,0h8.71V6.968A1.74,1.74,0,0,0,13.935,8.71H20.9v7.839H9.581A3.487,3.487,0,0,0,6.1,20.032v7.839H3.484A3.487,3.487,0,0,1,0,24.387ZM20.9,6.968H13.935V0ZM9.581,19.161h1.742a3.048,3.048,0,1,1,0,6.1h-.871V27A.871.871,0,0,1,8.71,27V20.032A.874.874,0,0,1,9.581,19.161Zm1.742,4.355a1.306,1.306,0,0,0,0-2.613h-.871v2.613Zm5.226-4.355H18.29A2.614,2.614,0,0,1,20.9,21.774v3.484a2.614,2.614,0,0,1-2.613,2.613H16.548A.874.874,0,0,1,15.677,27V20.032A.874.874,0,0,1,16.548,19.161Zm1.742,6.968a.874.874,0,0,0,.871-.871V21.774a.874.874,0,0,0-.871-.871h-.871v5.226Zm4.355-6.1a.874.874,0,0,1,.871-.871h2.613a.871.871,0,1,1,0,1.742H24.387v1.742h1.742a.871.871,0,1,1,0,1.742H24.387V27a.871.871,0,1,1-1.742,0V20.032Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.46e50e44313a5a66575ce0def0830434.svg";
export { ForwardRef as ReactComponent };